export default __webpack_public_path__ + "static/media/sf3.9da6efa9.jpg";